import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

const ROWS = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];

const OverviewPageSkeleton = () => (
	<Box sx={{ maxWidth: 1200, mx: "auto", pt: 2, width: "100%" }}>
		<TableContainer component={Paper}>
			<Table>
				<TableBody>
					{ROWS.map((key) => (
						<TableRow key={key}>
							<TableCell>
								<Skeleton variant="text" width={160} height={24} />
							</TableCell>
							<TableCell align="right">
								<Skeleton variant="text" width={80} height={24} />
							</TableCell>
							<TableCell align="right" width={40}>
								<Skeleton variant="circular" width={24} height={24} />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	</Box>
);

export default OverviewPageSkeleton;
